// extracted by mini-css-extract-plugin
export default {"header":"_3Z2iC___App-module__header"};